import { render, staticRenderFns } from "./hygl-app.vue?vue&type=template&id=2e5f5ffa&scoped=true"
import script from "./hygl-app.vue?vue&type=script&lang=js"
export * from "./hygl-app.vue?vue&type=script&lang=js"
import style0 from "../../views/member-page/assets/css/base.css?vue&type=style&index=0&id=2e5f5ffa&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5f5ffa",
  null
  
)

export default component.exports